/**
 * Banner: an inline page-flow callout that sits beside content rather than
 * blocking it, drawn as finixt-ui's. The two tones the pages use map onto
 * its warn and danger.
 */
import type { ReactNode } from 'react';

import { Banner as FinixtBanner } from '../../ui/finixt.js';

export type BannerTone = 'tertiary' | 'error';

interface BannerProps {
  tone?: BannerTone | undefined;
  title: ReactNode;
  children?: ReactNode;
}

export function Banner({ tone = 'tertiary', title, children }: BannerProps) {
  return (
    <FinixtBanner tone={tone === 'error' ? 'danger' : 'warn'} title={title}>
      {children}
    </FinixtBanner>
  );
}
